const SHOPIFY_STOREFRONT_URL =
  'https://spinellikilcollin.myshopify.com/api/graphql'
const SHOPIFY_ADMIN_URL =
  'https://spinellikilcollin.myshopify.com/admin/api/2025-01/graphql.json'
const NEW_SHOPIFY_STOREFRONT_URL =
  'https://spinellikilcollin.myshopify.com/api/2024-04/graphql.json'

export const config = {
  NEW_SHOPIFY_STOREFRONT_URL,
  SHOPIFY_ADMIN_URL,
  SHOPIFY_STOREFRONT_URL,
}
